module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkIn weight"
  }, [_c('mu-row', {
    staticClass: "content",
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "paddingRight",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "bigTxt first"
  }, [_vm._v("By this point in the program, many people have reported weight loss.")]), _vm._v(" "), _c('div', {
    staticClass: "bigTxt"
  }, [_vm._v("Fill us in on how you're getting along!")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', {
    staticStyle: {
      "width": "280px",
      "margin": "0 auto"
    }
  }, [_c('mu-card-text', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "lgTxt"
  }, [_vm._v(" Right now, I weigh...")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": "",
      "align": "center"
    }
  }, [(_vm.$store.state.user.settings.weight.measure === 'kg') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.kg),
      expression: "model.kg",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('kg')
    },
    attrs: {
      "type": "number",
      "data-vv-rules": 'required|min_value:0|max_value:635',
      "data-vv-name": "kg",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('kg'),
      "label": "KG",
      "hintText": "Weight in kg"
    },
    domProps: {
      "value": (_vm.model.kg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "kg", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Kilograms (kg)")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.lbs),
      expression: "model.lbs",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('lbs')
    },
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:750',
      "data-vv-name": "lbs",
      "errorText": _vm.errors.first('lbs'),
      "type": "number",
      "label": "POUNDS"
    },
    domProps: {
      "value": (_vm.model.lbs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "lbs", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Pounds (lbs)")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.stones),
      expression: "model.stones",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('stones')
    },
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:100',
      "data-vv-name": "stones",
      "type": "number"
    },
    domProps: {
      "value": (_vm.model.stones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "stones", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  Stones (st)\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "align": "center",
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.pounds),
      expression: "model.pounds",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('pounds')
    },
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "errorText": _vm.errors.first('pounds'),
      "type": "number"
    },
    domProps: {
      "value": (_vm.model.pounds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "pounds", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  Pounds (lbs)\n                ")])]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "disabled": _vm.isProcessing,
      "type": "button",
      "label": _vm.isProcessing ? _vm.$t('message.savingText') : _vm.$t('message.nextText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f0ca482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CheckIn/Weight.vue
// module id = 3250
// module chunks = 1